module.exports={
  message: {
    "Online Magazine": '飛雲雜誌',
    "Browse Occupations":'職業',
    "Find An Opportunity":"就業機會",
    "Qualifications":"Qualifications",
    "Self Assessment":"Self Assessment",
    "Home":"主頁",
    "Job detail":"Job detail",
     "Browse Courses":"課程",
    "Year":" 年 ",
    "Month":" 月 ",
    "Day":" 日 ",
    "monthsAgo":" 個月前",
    "weeksAgo":" 週前",
    "daysAgo":" 日前",
    "dayAgo":" 日前",
    "today":"  當日",
    "OccupationTitleSkillOrIndustry":"職業名稱，技能或行業",
    "All Education Level":"所有教育程度",

    "Requirement":"入職要求",
    "Experience":"工作經驗",
    "EducationLevel":"教育程度",
    "Skills":"技能",
    "outLook":"前景",
    "CareerPath":"晉升途徑",
    "Common Skills":"常見技能",
    "Growing Skills":"高增長技能",
    "Manpoweroutlook":"就業前景",
    "Automationpotential":"自動化可能性",
    "Private Sector":"私人機構",
    "Government Sector":"政府部門",
    "To know more":"想知更多",
    "Share with":"分享到",
    "RelatedJobOpportunities":"相關職位空缺",
    "Opportunities":"機會",
    "RelatedCourses":"相關課程",
    "QR Courses":"資歷名冊課程",
    "MOOC Courses":"大眾開放線上課程(MOOC)",
    "View all opportunities":"所有相關職位空缺",
    "View all qualifications":"所有相關課程",
    "Related Job functions":"相關職能：",
    "Discover career resources for educators and employers":"獲取更多有關培訓和職業發展的資料",
    "link":"[此]",
    "Low":"低",
    "High":"高",
    "forStart":" 「",
    "for":'的',
    "forEnd":'」 ',
    "Show more":"顯示更多",
    "Show less":"顯示更少",
    "Monthly salary":"月薪",
    "All Job Functions":"所有工作種類",
    "Find a Job Opportunity":"職位空缺",
    "Career quizzes":"職業小測試",
    "Hot Picks":"熱門文章",
    "hotPicks":"熱門",
    "Top 5 searches":"熱門搜尋",
    "View all":"所有職業",
    "FInd out more":"探索",
    "Stay":"助你找尋新工作，讓事業向前邁進。",
    "Job title, company name or skill, etc":"工作名稱，公司名稱或技能等",
    "Job Functions":"工作種類",
    "Search":"搜尋",
    "Learning and Upskilling":"學習與自我增值",
    "Learn from":"持續學習，裝備自己 — 尋找適合你的全日制、兼讀和網上課程",

    "What careers would suit you?":"甚麼職業最適合你？",
    "Various career":"助你探索林林總總職業的多個小測試，根據你的興趣和才能為你介紹合適的職業",
    "Take a quiz":"參加小測試",
    "Resources":"資源中心",
    "Feedback":"意見回饋",
    "About Human":"關於人力資源規劃委員會",
    "About Us":"關於我們",
    "Privacy Policy":"私隱政策",
    "Disclaimer":"免責聲明",
    "© 2019":" talent.gov.hk 將保留一切權利。",
    "Self-Assessment":"小測試",
    "developmentTip":"This section is under development. Please ignore. ",
    "FT":"全日制",
    "PT":"兼讀制",
    "DL":"遙距學習",
    "EL":"網上/移動學習",
    "Not Applicable":"不適用",
    "siteMap":"網頁導覽指南",
    "CourseInputTip":"課程名稱、機構、技能等",
    "All Areas of Study":"所有學科",
    "CEF":"CEF可獲發還款項課程",
    "All Learning Modes":"所有學習模式",
    "All Course Providers":"所有課程提供機構",
    "Fewer Options":"更少選項",
    "More Options":"更多選項",
    "results":"搜尋結果",
    "item":"項",
    "QR number:":"資歷名冊課程編號:",
    "Course Provider":"課程營辦者",
    "Area of Study":"學習及培訓範疇",
    "Learning mode":"授課模式",
    "Level":"級別",
    "Pace of learning":"學習步伐",
    "Effort":"所需時數",
    "Length":"修業期",
    "What youll learn":"學習要點",
    "Requirements":"職位要求",
    "Prerequisites":"課程需求",
    "Go to course page":"前往課程網站",
    "QR level 1-3":"基礎證書／文憑",
    "QR level 4":"高級證書／高級文憑／副學士",
    "QR level 5":"學士或同等資歷",
    "QR level 6":"深造文憑／深造證書／碩士課程",
    "QR level 7":"博士",
    "All Level of Positions":"所有年資",
    "All Job Types":"所有受僱形式",
    "Organization":"公司名稱",
    "Job function(s)":"工作種類",
    "Department":"部門",
    "Level of position":"年資",
    "Salary":"薪酬",
    "Job descriptions":"工作簡介",
    "Job duties":"職責",
    "Advertising date":"刊登日期",
    "All Level":"所有課程級別",
    "Show more":"顯示更多",
    "Show less":"顯示更少",
    "Apply on":"前往",
    "Apply on2":"申請",
    "Apply":"申請",
    "Other Job Opportunities":"其他工作機會",
    "ViewAll":"顯示更多",
    "jobTAndC":"為方便用戶 ，talent.gov.hk 提供由其他網站整合的職位空缺資訊及相關連結。talent.gov.hk對這些網站提供的内容不負有任何責任。",
    "EffortTip1":"每週",
    "EffortTip2":"小時",
    "week(s)":"週",
    "noSearchResult":"沒有相關的搜尋結果。",
    "Category":"類別",
    "Feature story":"專訪",
    "Side story":"專題",
    "Column":"專欄",
    "All":"全部",
    "Careers Exploration":"職業探索",
    "Vacancies Search":"空缺搜尋",
    "All articles":"所有文章",
    "on this page":"這頁可找到",
    "skillTips":"小提示:  按下個別技能，馬上搜尋相關課程。",
    "Relevant links":"相關連結",
    "assessmentDesc":"助你探索林林總總職業的多個小測試，根據你的興趣和才能為你介紹合適的職業。",
    "Skill-Career Quiz":"技能職業小測試",
    "Interest-Career Quiz":"興趣職業小測試",
    "Background-Career Quiz":"背景職業小測試",
    "getStarted":"立即開始",
    "skillDesc":"發揮你的專長。這個小測試助你快捷地尋找與你才能相應的職業。",
    "skillContent1":"透過回答簡單問題，告訴我們哪些是您已有、或者有興趣學習的的技能及知識。",
    "skillContent2":"我們會從資料庫中尋找與你的技能最接近的職業。回答首六條問題後，小測試會開始建議一系列職業。",
    "skillContent3":"你可以點按個別職業，以進一步了解不同職業的詳情。",
    "Start":"開始",
    "interestDesc1":"透過了解你的工作興趣，這個小測試可以助你探索或會喜歡並且有滿足感的工作。",
    "interestDesc2":"這個小測試沿用",
    "interestDesc3":"<a target='_blank' href='https://www.onetcenter.org/tools.html'>O*NET Mini Interest Profiler</a> ",
    "interestDesc4":"，包含30條你對不同工作活動喜好程度的問題。小測試會從資料庫中尋找與你的興趣最接近的職業。",
    "interestDesc5":"回答首六條問題後，小測試會開始建議一系列可能與你興趣匹配的職業。你可以隨時點按個別職業，以進一步了解不同職業的詳情。",
    "interestDesc6":"請仔細閱讀題目，並選擇你對每一項活動感興趣的程度：",
    "Strongly Dislike":"非常不喜歡",
    "Dislike":"不喜歡",
    "Unsure":"不確定",
    "Like":"喜歡",
    "Strongly Like":"非常喜歡",
    "interestDesc7":"你只需要考慮你喜歡或不喜歡做這些工作，而無須考慮你是否有足夠學歷或訓練從事這些工作，又或者是這些工作會有多少收入等等。",
    "interestDesc8":"答案沒有對錯，而這小測試並沒有限時，你可以慢慢回答問題。",
    "backgroundDesc":"嘗試透過這個小測試，了解與你的學歷和工作經驗相符的職業!",
    "Q":"問",
    "Your Career Matches":"你的職業配對",
    "resultTip":"結果將於回答六條題目後出現。",
    "Show result":"顯示結果",
    "Your highest education attained:":"你的最高學歷：",
    "Years of working experience:":"你的工作年資：",
    "Your field of study:":"你的主修科目：",
    "studyNote":"(「你的主修科目」主要是指專上教育的修讀科目。如果你並沒有就讀過任何專上教育課程，你可以選擇一項你希望在未來就讀的科目。）",
    "Your current occupation:":"你現時的職業：",
    "NoMatchingResults":"沒有匹配結果。",
    "Issue":"期號",
    "Number":"數字",
    "Years":"年",
    "Field of study":"主修科目",
    "Job title":"職業",
    "Try another quiz":"試試其他小測試",
    "Log in Facebook to view comments":"登入Facebook去顯示留言",
    "Feature Articles":"專題文章",
    "Columns":"專欄",
    "The Headline":"飛雲頭條",
    "View Comments":"顯示留言",
    "Read more:":"閱讀更多",
    "Recommended articles":"推介文章",
    "Related Occupations":"相關職業",
    "Published:":"發佈於:",
    "Select Issue":"選擇期刊",
    "Feature articles":"專題文章",
    "feedbackDesc":"多謝瀏覽 talent.gov.hk！我們歡迎你寶貴的意見，請填寫並提交以下表格(帶星號（*）的字段表示必須輸入)。",
    "sendSuccess":"你的意見已送出。感謝！",
    "Email":"電郵",
    "Types of user":"用戶類型",
    "Student":"學生",
    "Job seeker":"求職者",
    "Employee":"僱主",
    "Employer":"僱員",
    "CareerEducationCounsellor":"職業/培訓顧問",
    "Others":"其他",
    "Age group":"年齡組別",
    "Below 18":"18歲以下",
    "60 or above":"60歲或以上",
    "Type of feedback":"意見類型",
    "Enquiries":"查詢",
    "Outdated inaccurate information":"資料更正",
    "Suggestions and recommendations":"意見提供",
    "Collaboration opportunities":"合作機會",
    "Related Page":"相關頁面",
    "Contact information":"聯絡資料",
    "Feedback form":"意見",
    "Message":"訊息",
    "Please enter message":"請填寫訊息",
    "Submit":"提交",
    "Welcome Talent":"歡迎瀏覽talent.gov.hk",
    "Talent information":"talent.gov.hk是香港特別行政區政府人力資源規劃委員會設立的資訊平台，提供綜合的人力資訊，以協助公眾在職業、進修及發展路向上作出明智抉擇。",
    'Explorer':'「飛雲」是talent.gov.hk旗下的網上月刊，涵蓋與職場相關的熱門話題。',
    "Membership and Terms of Reference":"HRPC成員名單及職權範圍",
    "HRPC Information Centre":"HRPC資訊中心",
    "Press Release":"新聞稿",
    "Archive":"資料庫",
    "Contact Us":"聯絡我們",  
    "Address":"地址",
    "Telephone number":"電話號碼",
    "Please enter your email":"請輸入電郵地址",
    "Please select the type of user":"請選擇用戶類型",
    "Please select the age group":"請選擇年齡組別",
    "Please select type of feedback":"請選擇意見類型",
    "Feature stories":"專題文章",
    "Human Resources Planning Commission":"人力資源規劃委員會",
    "Email:":"電郵： ",
    "hrpc@cso.gov.hk":"hrpc@cso.gov.hk",
    "Address:":"地址： ",
    "Human Resources":"人力資源規劃委員會秘書處  香港添馬添美道2號政府總部東翼26樓",
    "Telephone:":"電話： ",
    "Fax:":"傳真： ",
    "2810 2586":"2810 2586",
    "2537 7068":"2537 7068",
    "ReratedCourses":"課程",
    "Slide to view more":"滾動去看看",
    "CEF_text":'持續進修基金(CEF)為有志進修的成年人提供持續教育和培訓資助。報讀已登記成為基金課程的持續教育和培訓課程，才符合申請發還課程款項的資格。有關申請手續及基金課程的名單，請瀏覽[link]',
    "CEF_link_text":"基金網頁",
    "CEF_link":"https://www.wfsfaa.gov.hk/cef/tc/index.htm",
    "QR_text":'[link]是由教育局局長根據《學術及職業資歷評審條例》設立，以載列獲資歷架構認可的資歷。根據該條例，香港學術及職業資歷評審局被指定為資歷名冊當局以發展和管理資歷名冊。',
    "QR_link_text":"資歷名冊",
    "QR_link":"https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-tc/index.html",
    "MOOC_text":'由edX提供的大規模開放線上課程。',
    "Copied link to clipboard":"已複製鏈結！",
    "Close":"關閉",
    "Beta Version":"測試版",
    "Powered by":"資料由以下提供",
    "QF level":"QF 級別 ",
    "Discover more career resources":"發現更多職業資源",
    "There are no":"沒有相關的搜尋結果。",
    "description":"talent.gov.hk囊括逾2萬個政府及私人職位空缺、3百多種職業簡介及上萬個課程，助你找到理想職業及提升技能！關於我們：talent.gov.hk是香港特別行政區政府人力資源規劃委員會設立的資訊平台，提供綜合的人力資訊，以協助公眾在職業、進修及發展路向上作出明智抉擇。",
    'mateMagezine':"飛雲雜誌",
    "benefits":"待遇",
    "location":"工作地點",
    "There are (number) jobs for you":"為你提供(number)份工作。",
    "Choose a job for more details!":"點擊左列的工作，查看詳情！",
    "Explorer_talent":"飛雲雜誌 - talent.gov.hk - 一站式人力資源資訊平台",
    "Explorer_desc":"「飛雲」是talent.gov.hk旗下的網上雜誌，涵蓋與職業、技能提升及職場相關的熱門話題",
    "Explorer_title":"飛雲雜誌",
    "Featured Jobs":"熱門職位空缺",
    "View all Featured Jobs":"所有空缺",
    "View all Occupation":"所有職業",
    "Popular Courses":"熱門課程",
    "View all Popular Courses":"所有課程",
    "Career Magazine": "飛雲雜誌",
    "Hot Occupations": "熱門職業",
    "Discover": "探索",
    "browseOccupations": "職業探索",
    "findJob": "空缺搜尋",
    "browseCouses": "瀏覽課程",
    "careerQuizzes": "職業小測試",
    "browseOccupations_text": "逾300個職業專頁助你了解發展機會。",
    "findJob_text": "政府及私人職位空缺資料庫助你尋找理想工作。",
    "browseCouses_text": "逾萬個課程助你提升技能及資歴。",
    "careerQuizzes_text": "小測試助你探索配合自己興趣、技能及經驗的職業。",
    "View all occupations": "所有職業",
    "View all findJob": "所有職位空缺",
    "View all browseCouses": "所有課程",
    "View all careerQuizzes": "參加小測試",
    "Let get started": "了解更多",
    "Discover Description": "透過我們的工具探索你的職業路向、進修選擇及工作機會。",
    "Default Page Title": "一站式人力資源資訊平台",
    "Careers_title":"職業探索",
    "Careers_desc":"在這裏探索你的理想職業！資料庫介紹逾300種職業，內容包括職業介紹、所需技能、入職要求及就業前景等，同時亦提供相關職位空缺及課程等資訊",
    "Courses_desc":"瀏覽上萬個學習及技能提升課程，資料庫涵蓋本港資歷名冊進修課程及海外網絡開放式課程，亦可同時搜尋持續進修基金(CEF)可獲發還款項課程資訊",
    "Courses_title": " - 課程 - talent.gov.hk",
    "Job_desc": "轉載超過2萬個政府及私人職位空缺，日日更新全職兼職好工，立即搜尋！",
    "Job_title": " - 職位空缺 - talent.gov.hk",
    "Self-Assessment_title":"職業小測試",
    "Self-Assessment_desc":"talent.gov.hk 提供三個根據你的技能、興趣、職業背景作評估的小測試，助你探索適合的職業",
    "Default Keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Explorer_Keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Careers_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Courses_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Job_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Self-Assessment_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "View all QR Courses": "所有資歷名冊課程",
    "View all MOOC Courses": "所有MOOC課程",
    "Entry level": "初級職位",
    "Part time": "兼職",
    "Government vacancies": "政府職位空缺",
    "Job Creation Scheme": "創造職位計劃",
    "Instant-filter": "快速搜尋",
    "min":"分鐘",
    "hour":"小時",
    "s":"",

  }
}